import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import LoadingAnimation from './anims/LoadingAnimation';
import axios from 'axios';
import { socket } from '../App';

const Logout = ({ setToken }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                // Notificar al backend para borrar cookie HttpOnly
                await axios.post('/api/auth/logout');
            } catch (error) {
                console.error("Error al cerrar sesión en el servidor:", error);
            } finally {
                if (socket.connected) {
                    socket.disconnect();
                }
                // Elimina cookies locales (si quedaron) y estado
                Cookies.remove('token');
                Cookies.remove('tokenExpiration');
                setToken('');

                setTimeout(() => {
                    navigate('/login');
                }, 500);
            }
        };

        performLogout();
    }, [navigate, setToken]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <LoadingAnimation />
        </div>
    );
};

export default Logout;
